module.exports = __webpack_public_path__ + "static/media/module_badge_proactive_parenting.0c5fece4.png";